var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "welcomepage" },
    [
      _c("div", { staticClass: "welcomepage", style: _vm.setWelImg }),
      _vm._v(" "),
      _c(
        "Modal",
        {
          attrs: {
            title: "修改密码",
            "cancel-text": "",
            "ok-text": "",
            mask: "",
            "mask-closable": false,
            "footer-hide": "",
          },
          model: {
            value: _vm.isShowPwModal,
            callback: function ($$v) {
              _vm.isShowPwModal = $$v
            },
            expression: "isShowPwModal",
          },
        },
        [
          _c("ChangePassword", {
            attrs: { openFrom: "welcome" },
            on: { onSwichPwModal: _vm.onSwichPwModal },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }